export default "/images/f63266189dfa5b501c7171ca9bc17b85.avif";